import styled from 'styled-components';
import tw from 'tailwind-styled-components';
import { Accordion as ReactAccordion, AccordionItemPanel } from 'react-accessible-accordion';

import { ForceTitleSpaceMode } from './types';
import { Text } from './../Typography';
import { ReactNode } from 'react';

export const Loading = styled(Text)`
  animation-name: bounce;
  animation-duration: 1500ms;
  animation-iteration-count: infinite;
  text-align: center;
  @keyframes bounce {
    from {
      opacity: 1;
    }
    45% {
      opacity: 0.25;
    }
    55% {
      opacity: 0.25;
    }
    to {
      opacity: 1;
    }
  }
`;

export const LocationDots = styled.span<{
  children?: ReactNode;
  className?: string;
}>`
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #000;
  border-radius: 4px;
  margin: 3px 10px;
`;

export const StyledLocationComponentAccordion = styled(ReactAccordion)<{
  $titleTogglePos: 'top' | 'center';
}>`
  border-bottom: 1px solid #010e54;
  .accordion__button:focus,
  .accordion__button:focus-visible {
    outline: none;
  }
  .accordion__item {
    border-top: 1px solid #010e54;
    &:first-child {
      border-top: none;
    }
  }

  .accordion__button {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 34px 0;
    width: 100%;
    text-align: left;
    border: none;
    position: relative;
    padding-right: 25px;
    @media screen and (max-width: 480px) {
      outline: 0;
    }
    @media (max-width: 767px) {
      padding: 20px 0;
    }
  }
  .accordion__button[aria-expanded='true'] {
    padding-bottom: 32px;
    @media (max-width: 767px) {
      padding: 20px 0;
    }

    .peek-text {
      display: none;
    }
  }

  .accordion__button::before {
    content: '+';
    font-size: 30px;
    display: block;
    position: absolute;
    right: 10px;
    top: ${({ $titleTogglePos }) => ($titleTogglePos === 'top' ? '20px' : '50%')};
    @media (min-width: 768px) {
      top: ${({ $titleTogglePos }) => ($titleTogglePos === 'top' ? '36px' : '50%')};
    }
    transform: ${({ $titleTogglePos }) =>
      $titleTogglePos === 'top' ? 'none' : 'translateY(-50%);'};
  }

  .accordion__button[aria-expanded='true']::before,
  .accordion__button[aria-selected='true']::before {
    content: '–';
  }

  [hidden] {
    display: none;
  }

  .accordion__button:hover #title {
    text-decoration: underline;
  }
  .accordion__button:focus #title {
    text-decoration: underline;
  }
  @media print {
    break-inside: avoid;
  }
`;
StyledLocationComponentAccordion.displayName = 'StyledAccordion';

export const StyledLocationComponentAccordionItemPanel = tw(AccordionItemPanel)<{
  $isNumbered?: boolean;
  $hasTitle?: boolean;
  $forceTitleSpace?: ForceTitleSpaceMode;
}>`
  animate-fadeIn
  mb-5
  ${({ $hasTitle, $forceTitleSpace }) => {
    if (!$hasTitle && $forceTitleSpace && $forceTitleSpace !== 'both') {
      return $forceTitleSpace === 'none' ? 'sm:-mt-12 md:-mt-16' : 'md:-mt-14';
    }
    return '';
  }}
`;
StyledLocationComponentAccordionItemPanel.displayName = 'StyledAccordionItemPanel';

export const LocationComponentFilterItem = tw.button<{ $active?: boolean }>`
border-corporate-blue
inline-block
pt-2
mr-5
md:mr-30
${({ $active }) => ($active ? 'border-b-2' : '')}

`;
LocationComponentFilterItem.displayName = 'LocationComponentFilterItem';
